import { createStore, applyMiddleware, compose } from "redux";

import thunkMiddleware from "redux-thunk";
import { routerMiddleware } from "react-router-redux";

import history from "./history";
import reducers from "./reducers";

const isDev = process.env.NODE_ENV !== "production";

let middleWares = applyMiddleware(routerMiddleware(history), thunkMiddleware);

if (isDev) {
  const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

  middleWares = composeEnhancers(
    middleWares,
  );
}

const store = createStore(reducers, middleWares);

if (module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept(() => {
    // eslint-disable-next-line
    const nextRootReducer = require("./reducers").default;
    store.replaceReducer(nextRootReducer);
  });
}

export default store;
